'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { BrandRecommendationFragmentFragmentDoc } from '@packages/gql/generated/shopping/BrandRecommendationFragmentFragmentDoc';
import { Link } from '@packages/modules/src/Link/Link';
import { Card } from '@packages/shared/src/ui/Card/Card';
import { Image } from '@packages/shared/src/ui/Image/Image';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinCategoryClick } from '@packages/tracking/src/types/events';

/* GraphQL */ `
  fragment BrandRecommendationFragment on BrandRecommendation {
    brand {
      image
      name
      url
      categoryId
      parentName
      includedInCategories
    }
    tracking {
      token
    }
  }
`;

export type RecoBrandCardProps = {
  /**
   * Position of category card in the recommendation list, starting with 1.
   */
  position: number;
  recommendationData: FragmentType<typeof BrandRecommendationFragmentFragmentDoc>;
  /**
   * Recommendation type abbreviation, e.g. "prudsys_c2c"
   */
  rdeTypeAbbr?: string;
};

export const RecoBrandCard = ({
  recommendationData,
  position,
  rdeTypeAbbr,
}: RecoBrandCardProps) => {
  const dispatchGTMEvent = useTracking();
  const { brand, tracking } = getFragmentData(
    BrandRecommendationFragmentFragmentDoc,
    recommendationData,
  );

  return (
    <li>
      <Card className="relative h-[130px]">
        <Link
          href={brand.url}
          onClick={() => {
            dispatchGTMEvent<GTMEventGlycerinCategoryClick>({
              event: 'CategoryClick',
              CategoryClickData: {
                category: 'category-click',
                categoryId: brand.categoryId,
                listPosition: position,
                recoId: rdeTypeAbbr,
                custom: {
                  trackingToken: tracking.token,
                },
              },
            });
          }}
          className="relative block h-full w-full [&>img]:grayscale hover:[&>img]:grayscale-0"
        >
          <Image
            src={`${brand.image}?$brand_pace$`}
            alt={`Brand ${brand.name} Logo`}
            fill
            className="object-contain"
          />
        </Link>
      </Card>
    </li>
  );
};
